<template>
  <div class="login-container">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
        <div class="shape shape-5"></div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="login-content">
      <!-- 左侧品牌区域 -->
      <div class="brand-section">
        <div class="brand-content">
          <div class="logo-container">
            <!-- <img v-if="loginInfo.logo" :src="loginInfo.logo" alt="Logo" class="logo"> v-else-->
            <div  class="logo-placeholder">
              <i class="el-icon-shopping-cart-2"></i>
            </div>
          </div>
          <h1 class="brand-title">{{ loginInfo.systemTitle }}</h1>
          <p class="brand-subtitle">欢迎来到智能购物平台</p>
          <div class="brand-features">
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>安全可靠的购物体验</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>丰富的商品选择</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>便捷的支付方式</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧登录表单区域 -->
      <div class="login-form-section">
        <div class="login-card">
          <div class="login-header">
            <h2 class="login-title">{{ $t('shopLogin.welcomeBack') }}</h2>
            <p class="login-subtitle">{{ $t('shopLogin.enterCredentials') }}</p>
          </div>

          <el-form class="login-form" :model="loginInfo" :rules="formRules" ref="loginForm">
            <!-- 用户名输入框 -->
            <el-form-item prop="username" class="form-item">
              <div class="input-wrapper">
                <i class="input-icon el-icon-user"></i>
                <el-input v-model="loginInfo.username" :placeholder="$t('shopLogin.usernamePlaceholder')" maxlength="20"
                  autocomplete="off" autofocus @keyup.enter.native="doLogin" class="custom-input">
                </el-input>
              </div>
            </el-form-item>

            <!-- 密码输入框 -->
            <el-form-item prop="passwd" class="form-item">
              <div class="input-wrapper">
                <i class="input-icon el-icon-lock"></i>
                <el-input v-model="loginInfo.passwd" type="password" :placeholder="$t('shopLogin.passwordPlaceholder')"
                  maxlength="20" autocomplete="off" @keyup.enter.native="doLogin" class="custom-input">
                </el-input>
              </div>
            </el-form-item>

            <!-- 验证码输入框 -->
            <el-form-item prop="validateCode" class="form-item">
              <div class="input-wrapper">
                <i class="input-icon el-icon-key"></i>
                <el-input v-model="loginInfo.validateCode" :placeholder="$t('shopLogin.codePlaceholder')" maxlength="6"
                  autocomplete="off" @keyup.enter.native="doLogin" class="custom-input">
                </el-input>
                <div class="code-wrapper">
                  <img :src="loginInfo.codeImage" :alt="$t('shopLogin.refreshCode')" class="code-image"
                    @click="generateCode" v-if="loginInfo.codeImage">
                  <div v-else class="code-loading">
                    <i class="el-icon-loading"></i>
                  </div>
                </div>
              </div>
            </el-form-item>

            <!-- 登录按钮 -->
            <el-form-item class="form-item">
              <el-button type="primary" class="login-button" :loading="loginLoading" @click="doLogin">
                <span v-if="!loginLoading">{{ $t('shopLogin.signIn') }}</span>
                <span v-else>{{ $t('shopLogin.signingIn') }}</span>
              </el-button>
            </el-form-item>
          </el-form>

          <!-- 底部链接 -->
          <div class="login-footer">
            <p class="register-text">
              {{ $t('shopLogin.noAccount') }}
              <a href="javascript:void(0)" @click="_doRegister" class="register-link">
                {{ $t('shopLogin.register') }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 初始化数据组件 -->
    <init-data ref="initData"></init-data>
  </div>
</template>

<script>
import {  pcUserLogin, generatorValidateCode } from '@/api/frame/loginApi'
import { listSystemInfo } from '@/api/system/systemInfoManageApi'

import InitData from '@/components/frame/initData/initData'

export default {
  name: 'Login',
  components: {
    InitData
  },
  data() {
    return {
      loginLoading: false,
      loginInfo: {
        logo: '',
        username: '18909711443',
        passwd: '18909711443',
        validateCode: '',
        errorInfo: '',
        codeImage: '',
        systemTitle: ''
      },
      formRules: {
        username: [
          { required: true, message: this.$t('shopLogin.usernameRequired'), trigger: 'blur' },
          { min: 3, max: 20, message: this.$t('shopLogin.usernameLength'), trigger: 'blur' }
        ],
        passwd: [
          { required: true, message: this.$t('shopLogin.passwordRequired'), trigger: 'blur' },
          { min: 5, max: 20, message: this.$t('shopLogin.passwordLength'), trigger: 'blur' }
        ],
        validateCode: [
          { required: true, message: this.$t('shopLogin.codeRequired'), trigger: 'blur' },
          { len: 4, message: this.$t('shopLogin.codeLength'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.clearCacheData()
    this._loadSysInfo()
    this.generateCode()
  },
  methods: {
    clearCacheData() {
      localStorage.clear()
      sessionStorage.clear()
    },
    async _loadSysInfo() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 });
        Object.assign(this.loginInfo, data[0])
        localStorage.setItem('_sysInfo', JSON.stringify(data[0]))
      } catch (error) {
        console.log("加载系统信息失败", error)
        localStorage.setItem('_sysInfo', JSON.stringify({ logo: 'HC' }))
        this.loginInfo.errorInfo = error.message
      }
    },
    async doLogin() {
      try {
        const valid = await this.$refs.loginForm.validate()
        if (!valid) return

        this.loginLoading = true
        const res = await pcUserLogin(this.loginInfo)

        if (res.code && res.code !== '0') {
          this.$message.error(res.msg)
          this.generateCode() // 刷新验证码
          return
        }

        localStorage.setItem('token', res.token)

        this.$message.success(this.$t('shopLogin.loginSuccess'))
        this.$refs.initData.loadShopInfo({ url: '/views/index/index' })
      } catch (error) {
        this.$message.error(error.message || this.$t('shopLogin.loginFailed'))
        this.loginInfo.errorInfo = error.message
        this.generateCode() // 刷新验证码
      } finally {
        this.loginLoading = false
      }
    },
    _doRegister() {
      this.$router.push('/pages/frame/register')
    },
    async generateCode() {
      try {
        const res = await generatorValidateCode({ _uId: '123' })
        this.loginInfo.codeImage = res
      } catch (error) {
        console.log('请求验证码失败', error)
      }
    }
  },
  beforeDestroy() {
    console.log("登录页面销毁调用")
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.floating-shapes {
  position: relative;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 60%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  top: 80%;
  left: 20%;
  animation-delay: 4s;
}

.shape-4 {
  width: 100px;
  height: 100px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

.shape-5 {
  width: 40px;
  height: 40px;
  top: 40%;
  left: 60%;
  animation-delay: 3s;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }

  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* 主要内容区域 */
.login-content {
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  overflow: hidden;
  z-index: 1;
}

/* 左侧品牌区域 */
.brand-section {
  flex: 1;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
}

.brand-content {
  text-align: center;
  max-width: 400px;
}

.logo-container {
  margin-bottom: 30px;
}

.logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  padding: 15px;
}

.logo-placeholder {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 40px;
  color: white;
}

.brand-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.brand-subtitle {
  font-size: 16px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.brand-features {
  text-align: left;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 14px;
}

.feature-item i {
  margin-right: 10px;
  color: #4ade80;
  font-size: 16px;
}

/* 右侧登录表单区域 */
.login-form-section {
  flex: 1;
  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 10px;
}

.login-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.login-form {
  margin-bottom: 30px;
}

.form-item {
  margin-bottom: 25px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  color: #9ca3af;
  font-size: 18px;
  z-index: 1;
}

.custom-input {
  width: 100%;
}

.custom-input>>>.el-input__inner {
  height: 50px;
  padding-left: 45px;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  background: #f9fafb;
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-input>>>.el-input__inner:focus {
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.code-wrapper {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.code-wrapper:hover {
  transform: translateY(-50%) scale(1.05);
}

.code-image {
  width: 100px;
  height: 40px;
  display: block;
}

.code-loading {
  width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  color: #9ca3af;
}

.login-button {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

.login-button:active {
  transform: translateY(0);
}

.login-footer {
  text-align: center;
}

.register-text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.register-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.register-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-content {
    flex-direction: column;
    margin: 20px;
    border-radius: 15px;
  }

  .brand-section {
    padding: 40px 20px;
  }

  .login-form-section {
    padding: 40px 20px;
  }

  .brand-title {
    font-size: 24px;
  }

  .login-title {
    font-size: 24px;
  }

  .shape {
    display: none;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }

  .login-content {
    margin: 10px;
  }

  .brand-section,
  .login-form-section {
    padding: 30px 15px;
  }
}
</style>